import React from "react";
import {
  BrandIcons,
  ColoredIcons,
  FilledIcons,
  OutlinedIcons,
} from "@toddle-edu/ds-icons";

export const ALL_ICONS = {
  ...BrandIcons,
  ...ColoredIcons,
  ...FilledIcons,
  ...OutlinedIcons,
};

/**
 * Resolves an icon name to a renderable JSX element.
 * Duotone icons (when a duotoneMap is supplied) are returned as-is — they ship
 * with their own background/colouring. Plain ds-icons classes are instantiated
 * here so callers always get a renderable element regardless of source.
 *
 * @param {string} name
 * @param {Object} [duotoneMap] map of name → { iconName, component (JSX element) }
 * @returns {{ element: JSX.Element, isDuotone: boolean } | null}
 */
export const resolveIconByName = (name, duotoneMap) => {
  if (!name) return null;
  const duotone = duotoneMap?.[name];
  if (duotone) return { element: duotone.component, isDuotone: true };
  const Icon = ALL_ICONS[name];
  return Icon ? { element: <Icon />, isDuotone: false } : null;
};
